import { useOptionsStore } from '@stores/options'

import { useOptionsApi } from '@api/options.hook'

export const useMiddlewareOptionsReady = async (): Promise<boolean> => {
  const optionsStore = useOptionsStore()

  if (!optionsStore.hasData) {
    await useOptionsApi()
  }

  return optionsStore.hasData
}
